<div class="card card-border patching-shell">
  <div class="card-header patching-header">
    <div>
      <h5 class="mb-1">Patching</h5>
      <p class="patching-subtitle mb-0">
        Choose an environment and schedule the next patching window for the matching instances.
      </p>
    </div>
  </div>

  <div class="card-body" *ngIf="!showPatchingWindow && !showPatchingHistory">
    <div class="patching-controls">
      <div class="hero-panel">
        <div class="hero-copy">
          <span class="eyebrow">Patching Planner</span>
          <h6>Select an environment</h6>
          <p class="mb-0">
            Start by selecting a value, then choose the instances you want to include in the patching window.
          </p>
        </div>

        <div class="hero-actions">
          <button type="button" class="btn btn-light view-history-btn" (click)="openPatchingHistory()">
            View All Patching Info
          </button>

          <div class="tag-filter-card" *ngIf="hasEnvTags; else noTagsFound">
            <label for="patchingTagValues" class="filter-label">Environment</label>
            <select
              id="patchingTagValues"
              class="form-control environment-select"
              [(ngModel)]="selectedTagValue"
              data-live-search="true"
              (change)="changeTagValue()"
            >
              <option *ngFor="let value of tagValueList" [value]="value">{{ value || "-" }}</option>
            </select>
            <div class="helper-text">Matching instances will appear below.</div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-card">
      <div class="table-title-row">
        <div>
          <h6 class="mb-1">Matched Instances</h6>
          <p class="mb-0 text-xs text-slate-500">Select one or more instances, then continue to the next step.</p>
        </div>
        <div class="results-pill" *ngIf="!loading">{{ instancesList.length }} found</div>
      </div>

      <div class="overflow-auto">
        <table class="table table-docs table-hover align-middle patching-table">
          <thead>
            <tr>
              <th class="checkbox-col"></th>
              <th>S.N.</th>
              <th *ngFor="let h of headers">{{ h.name }}</th>
            </tr>
          </thead>

          <tbody *ngIf="instancesList.length > 0 && !loading">
            <tr
              *ngFor="
                let instance of instancesList
                  | paginate: { itemsPerPage: itemsPerPage, currentPage: currentPage };
                let i = index;
                trackBy: trackByInstance
              "
            >
              <td class="checkbox-col">
                <input autocomplete="off" type="checkbox" [(ngModel)]="instance.actionStart" />
              </td>
              <td>{{ (currentPage - 1) * itemsPerPage + i + 1 }}</td>
              <td *ngFor="let h of headers">
                <div *ngIf="!h.status">{{ instance[h.id] || "-" }}</div>
                <div *ngIf="h.status" class="status-pill" [ngClass]="getStatusClass(instance[h.id])">
                  {{ instance[h.id] || "-" }}
                </div>
              </td>
            </tr>
          </tbody>

          <tbody *ngIf="loading">
            <tr>
              <td [attr.colspan]="headers.length + 2" class="center">
                Looking for instances in <span class="bold-text">{{ regionId }}</span>...
              </td>
            </tr>
          </tbody>

          <tbody *ngIf="!loading && hasEnvTags && instancesList.length == 0">
            <tr>
              <td [attr.colspan]="headers.length + 2" class="center">
                No instances found for <span class="bold-text">{{ selectedTagValue || "-" }}</span> in <span class="bold-text">{{ regionId }}</span>.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="pagination-row" *ngIf="instancesList.length > itemsPerPage && !loading">
        <pagination-controls
          previousLabel="Prev"
          nextLabel="Next"
          (pageChange)="currentPage = $event"
        ></pagination-controls>
      </div>

      <div class="selection-action-bar" *ngIf="getSelectedInstances().length > 0">
        <div class="selection-preview">
          {{ getSelectedInstances().length }} instance(s) selected and ready for the next step.
        </div>
        <button type="button" class="btn next-step-btn" (click)="goToPatchingWindow()">Next</button>
      </div>
    </div>
  </div>

  <div class="card-body patching-step-two" *ngIf="showPatchingWindow">
    <div class="schedule-panel action-panel full-step-panel">
      <div class="step-toolbar">
        <button type="button" class="btn btn-light toolbar-btn" (click)="goBackToSelection()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
          Back
        </button>
        <div class="step-indicator">Step 2 of 2</div>
      </div>

      <div class="step-two-copy">
        <h6>Next Patching Window</h6>
        <p>
          Set the next date and time for the {{ getSelectedInstances().length }} selected instance(s).
        </p>
      </div>

      <div class="patching-form-shell">
        <div class="patch-window-form">
          <label class="filter-label mb-0" for="patchingEnvironment">Environment</label>
          <input
            id="patchingEnvironment"
            type="text"
            class="form-control patch-input"
            [ngModel]="selectedTagValue"
            readonly
          />

          <label class="filter-label mb-0" for="patchDateTime">Next Patching Date &amp; Time</label>
          <input
            id="patchDateTime"
            type="datetime-local"
            class="form-control patch-datetime cursor-pointer"
            [(ngModel)]="patchDateTime"
          />

          <label class="filter-label mb-0" for="toEmailCommunication">To Email Communication</label>
          <input
            id="toEmailCommunication"
            type="text"
            class="form-control patch-input"
            [(ngModel)]="toEmailCommunication"
            placeholder="user1@example.com, user2@example.com"
          />

          <label class="filter-label mb-0" for="ccEmailCommunication">CC Email Communication</label>
          <input
            id="ccEmailCommunication"
            type="text"
            class="form-control patch-input"
            [(ngModel)]="ccEmailCommunication"
            placeholder="optional@example.com, another@example.com"
          />

          <div class="selection-preview" *ngIf="patchDateTime">
            Planned for <span class="mono">{{ patchDateTime }}</span>
          </div>
        </div>

        <div class="patch-summary-card">
          <div class="summary-label">Selected Instances</div>
          <div class="summary-count">{{ getSelectedInstances().length }}</div>
          <div class="summary-text">Ready for scheduling</div>

          <button
            type="button"
            class="btn save-btn"
            [disabled]="!canSavePatchingWindow() || saving"
            [ngClass]="{ 'disabled-btn': !canSavePatchingWindow() || saving }"
            (click)="savePatchingWindow()"
          >
            {{ saving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="card-body" *ngIf="showPatchingHistory">
    <app-patching-history
      [accountId]="accountId"
      [environmentOptions]="tagValueList"
      (hideModal)="hidePatchingHistory()"
    ></app-patching-history>
  </div>
</div>

<ng-template #noTagsFound>
  <div class="tag-filter-card empty-state">
    <div class="empty-title">No Env or Environment tag keys found</div>
    <div class="helper-text">
      This account and region do not currently expose matching environment tag keys for patching.
    </div>
  </div>
</ng-template>
